<template>
    
</template>
<script>

import store from '../../../store';
import { mapActions } from 'vuex'
export default {
     data() {
        return {
            StoreStateT: store.state.Transactions,
            StoreStateAO : store.state.AOD,
            StoreStateLookup: store.state.Lookup,

        }
     },
      methods : {
    
    ...mapActions([
        "FundList",
        "GetLookupOnline",
        "TrnxCifCustomerAccountInfo",
        "TokenValidate",
        "TrnxCifCustomerInfo"
        ]),
        CreateTempId() {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c=='x' ? r :(r&0x3|0x8)).toString(16);
            });
            this.StoreStateT.OnlineTransactionappId = uuid;
            //this.TransactionId =  uuid;
        },
      },
mounted(){
    
    store.commit("ResetState_ClientDetails");
    store.commit("ResetTransactionDetails");
    store.commit("ResetState_AD");
    
    var url = new URL(window.location.href);
    var url_string = url.search;
    var accountID = url.searchParams.get('account');
    var scheme = url.searchParams.get('productcode')
    var plan = url.searchParams.get('plan');
    var userid = url.searchParams.get('userid');
    var username  = url.searchParams.get('username')
    var iaccessuserid = url.searchParams.get('accountId')
    var token = url.searchParams.get("token")
    //UT-> 0013607
    //PRS-> 0019506
       //http://192.168.11.154:8082/transaction?account=010002606653&productcode=PRSM&plan=PRS&userid=940305-13-5708&username=mohan2813&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6W3siUm9sZUNvZGUiOiJSZXRhaWxzSW52ZXN0b3IiLCJSb2xlTmFtZSI6IlJldGFpbHNJbnZlc3RvciJ9XSwiaWF0IjoxNTg3MzY2OTI3LCJleHAiOjE1ODczNjg3MjcsImlzcyI6InRlc3QiLCJzdWIiOiJtb2hhbjI4MTMifQ.LMfkbp2HKur9MAGwRvzj88sm3sVA4eS1BfG7_no73d6O4rmTY96ByiPpwWSd9Eq9Yk7B8lfPuNEH-iSFj5Q79A


       //http://192.168.11.154:8082/transaction?account=010002162969&productcode=SAOF&plan=CS&userid=910120-10-5310

       //http://192.168.11.154:8082/transaction?account=010002679590&productcode=GOF&plan=CS&userid=501225-10-5643

       //http://192.168.11.154:8082/transaction?account=0016756&productcode=SIPG&plan=CS&userid=61070-60-85236&username=mohan2813&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6W3siUm9sZUNvZGUiOiJSZXRhaWxzSW52ZXN0b3IiLCJSb2xlTmFtZSI6IlJldGFpbHNJbnZlc3RvciJ9XSwiaWF0IjoxNTg3MzY2OTI3LCJleHAiOjE1ODczNjg3MjcsImlzcyI6InRlc3QiLCJzdWIiOiJtb2hhbjI4MTMifQ.LMfkbp2HKur9MAGwRvzj88sm3sVA4eS1BfG7_no73d6O4rmTY96ByiPpwWSd9Eq9Yk7B8lfPuNEH-iSFj5Q79A
 
 //http://192.168.11.154:8082/transaction?account=null&productcode=SIPG&plan=CS&userid=61070-60-85236&username=mohan2813&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6W3siUm9sZUNvZGUiOiJSZXRhaWxzSW52ZXN0b3IiLCJSb2xlTmFtZSI6IlJldGFpbHNJbnZlc3RvciJ9XSwiaWF0IjoxNTg3MzY2OTI3LCJleHAiOjE1ODczNjg3MjcsImlzcyI6InRlc3QiLCJzdWIiOiJtb2hhbjI4MTMifQ.LMfkbp2HKur9MAGwRvzj88sm3sVA4eS1BfG7_no73d6O4rmTY96ByiPpwWSd9Eq9Yk7B8lfPuNEH-iSFj5Q79A

//http://192.168.11.154:8082/transaction?account={}&productcode={}&plan={}&userid={}&username={}&token=e{} 

       //http://192.168.11.154:8082/transaction?account=0016756&productcode=SIPG&plan=CS&userid=61070-60-85236

       //http://192.168.11.154:8082/transaction?account=010002679590&productcode=GOF&plan=CS&userid=501225-10-5643
       
       //http://192.168.11.154:8082/transaction?account=010002869846&productcode=PRSG&plan=PRS&userid=910328-10-6187


       //http://192.168.11.154:8082/transaction?account=0013607&productcode=SDF&plan=CS&userid=851215-07-5401


       //http://192.168.11.154:8082/transaction?account=0009268&productcode=SDF&plan=EPF&userid=760626-10-5384 
   // https://investdev.affinhwangam.com/transaction?account=0031381&productcode=SIF&plan=CS&userid=870520-01-5230 
     

     
   // https://investdev.affinhwangam.com/transaction?account=010002679590&productcode=GOF&plan=CS&userid=501225-10-5643
   
  /*  
  userid = '760626-10-5384'
        accountID = '0009268'
        scheme='SDF'
        plan = 'EPF'
        username = '760626-10-5384'
        transaction?account=010002730005&productcode=SIF&plan=CS&userid=840427105189

  transaction?account=0031381&productcode=SIF&plan=CS&userid=870520-01-5230 

  transaction?account=0031381&productcode=SIF&plan=CS&userid=870520-01-5230 
    userid = '840427105189'
        accountID = '010002730005'
        scheme='PRSG'
        plan = 'PRS' 
        username = 'mohan2813'
        */
        /*    userid = '910328106187'
        accountID = '010002887812'
        scheme='BAL'
        plan = 'EPF'
        username = 'mohan2813'


  transaction?account=0031381&productcode=SIF&plan=CS&userid=870520-01-5230 
       userid = '870520-01-5230'
        accountID = '0031381'
        scheme='SIF'
        plan = 'CS'
        username = 'mohan2813' 

  transaction?account=0016871&productcode=SOF&plan=CS&userid=610706-08-5236 

        userid = '610706-08-5236'
        accountID = '0016871'
        scheme='SOF'
        plan = 'CS'
        username = '610706-08-5236'

        
        userid = '760626-10-5384'
        accountID = '0009268'
        scheme='SDF'
        plan = 'EPF'
        username = '760626-10-5384'
//0a8b6d5e-7903-429e-8bbb-d4a513b03969-20200122094329


        userid = '760626-10-5384'
        accountID = '0041975'
        scheme='PRSG'
        plan = 'PRS'
        username = '760626-10-5384'
        //2d1ad886-949c-4dc2-8279-c412ed6e4503-20200122100147

 userid = '760626-10-5384'
        accountID = '0009268'
        scheme='SDF'
        plan = 'EPF'
        username = '760626-10-5384'


        userid = '760626-10-5384'
        accountID = '0009268'
        scheme='SIF'
        plan = 'CS'
        username = '760626-10-5384'
*/  

    
    if((accountID ===null)||(accountID ==='null')||(accountID ===undefined)||(accountID ==='undefined')){
        alert("Account ID is not provided")
        return false;
    }
   if((scheme ===null)||(scheme ==='null')||(scheme ===undefined)||(scheme ==='undefined')){
        alert("Scheme is not provided")
        return false; 
    }
    if((plan ===null)||(plan ==='null')||(plan ===undefined)||(plan ==='undefined')){
         alert("Plan is not provided")
        return false;
    }

    if((userid ===null)||(userid ==='null')||(userid ===undefined)||(userid ==='undefined')){
         alert("User id is not provided")
        return false;
    }

    if((username ===null)||(username ==='null')||(username ===undefined)||(username ==='undefined')){
         alert("Username is not provided")
        return false;
    }

     if((token ===null)||(token ==='null')||(token ===undefined)||(token ==='undefined')){
         alert("Token is not provided")
        return false;
    }
    

    this.$q.loading.show({
        spinnerSize: 50,
    })
    var vm = this;
    vm.TokenValidate({
        AuthToken:token,
        AuthUser:username
    }).then(res =>{
        if(res=== true){
            if((accountID!=undefined)||(scheme!=undefined)||(plan!=undefined)){
                if((plan.toUpperCase()=='CS')||(plan.toUpperCase()=='EPF')){
                //TODO route to UTF page
                    var tempuserid = userid.replace('-','');
                    tempuserid= tempuserid.replace('-','');
                    vm.StoreStateT.OnlineTransactionUserID = tempuserid;
                    vm.StoreStateT.OnlineTransactionAccount = accountID;
                    vm.StoreStateT.OnlineTransactionScheme = scheme;
                    vm.StoreStateT.OnlineTransactionPlan = plan.toUpperCase();
                    vm.StoreStateT.OnlineTransactionType = 'UTF'
                    vm.StoreStateT.OnlineTransactionUsername = username;
                    vm.StoreStateT.OnlineTransactionIaccessUserID = iaccessuserid
                    vm.CreateTempId()
                    vm.FundList().then(res =>{
                        if(res != true){
                          //  console.log(res.length)
                            //this.StoreStateT.OnlineTransactionCurrency =
                            for(var i=0; i< res.length; i++){
                                if(res[i].Scheme == vm.StoreStateT.OnlineTransactionScheme){
                                    vm.StoreStateT.OnlineTransactionCurrency = res[i].Currency
                                }
                            }
                            vm.TrnxCifCustomerAccountInfo().then(res=>{
                                if(res===true){
                                    vm.TrnxCifCustomerInfo().then(res=>{
                                      if(res===true){

                                        vm.$q.loading.hide()
                                        vm.$router.push({ name: 'onlineRedemption' })
                                      }else{

                                        alert(res)
                                        vm.$q.loading.hide()
                                      }
                                    })
                            //  this.$q.loading.hide()
                                }else{
                                alert(res)
                                vm.$q.loading.hide()
                                }
                            })

                            
                        }else{
                            alert('Scheme Listing API Down')
                        }
                    })
                    
                }else if(plan.toUpperCase()=='PRS'){
                //TODO route PRS page 

                    var tempuserid = userid.replace('-','');
                    tempuserid= tempuserid.replace('-','');
                    
                    vm.StoreStateT.OnlineTransactionUserID = tempuserid;
                    vm.StoreStateT.OnlineTransactionAccount = accountID;
                    vm.StoreStateT.OnlineTransactionScheme = scheme;
                    vm.StoreStateT.OnlineTransactionType = 'PRS'
                    vm.StoreStateT.OnlineTransactionPlan = plan.toUpperCase();
                    vm.StoreStateT.OnlineTransactionUsername = username;
                    vm.StoreStateT.OnlineTransactionIaccessUserID = iaccessuserid
                    vm.CreateTempId()
                    
                    vm.GetLookupOnline().then(res =>{
                        if(res == true){
                            vm.FundList().then(res =>{
                            if(res != false){
                                //console.log(res.length)
                                //this.StoreStateT.OnlineTransactionCurrency =
                                for(var i=0; i< res.length; i++){
                                    if(res[i].Scheme == vm.StoreStateT.OnlineTransactionScheme){
                                        vm.StoreStateT.OnlineTransactionCurrency = res[i].Currency
                                    }
                                }
                                vm.TrnxCifCustomerAccountInfo().then(res=>{
                                if(res===true){
                                    vm.TrnxCifCustomerInfo().then(res=>{
                                      if(res===true){
                                            vm.$q.loading.hide()
                                            vm.$q.dialog({
                                            //title:"Withdrawal Reason",
                                            message:"Select one WITHDRAWAL REASON.",
                                            options: {
                                                model:'WithdrawalReason',
                                                type: 'radio',
                                                items: vm.StoreStateLookup.Form.PRSWithdrawalReason
                                            },
                                                cancel: true,
                                                persistent: true
                                            })
                                            .onOk(data => {
                                                vm.StoreStateT.OnlineTransactionWithdrawalReason = data
                                                
                                                vm.$router.push({ name: 'onlineRedemption' })
                                            })
                                            .onCancel(() => {
                                            window.location.href = 'http://192.168.10.229/OneHopLink/modules/customers/new-account-dash#/account?id='+this.StoreStateT.OnlineTransactionIaccessUserID+'&b=1'
                                            
                                            })
                                      }else{

                                        alert(res)
                                        vm.$q.loading.hide()
                                      }
                                    })
                                 
                            //  this.$q.loading.hide()
                                }else{
                                alert(res)
                                vm.$q.loading.hide()
                                }
                            })
                              // this.$router.push({ name: 'onlineRedemption' })
                            }else{
                                alert('Scheme Listing API Down')
                            }
                        })
                        }
                    })
                }
            }
        }else if(res === -1){
            this.$q.loading.hide()
            this.$q.dialog({
            message:"Sorry. It appear your session expired, please re-login to begin the transaction.",
            persistent: true
            })
            .onOk(data => {
                // window.location.href = 'http://192.168.10.229/OneHopLink/modules/customers/new-account-dash#/account?id='+this.StoreStateT.OnlineTransactionIaccessUserID+'&b=1'              
            })
        }else if(res==="Token is not valid"){
            
            this.$q.loading.hide()
            this.$q.dialog({
            message:"Sorry. It appear your session expired, please re-login to begin the transaction.",
            persistent: true
            }).onOk(data => {
                // window.location.href = 'http://192.168.10.229/OneHopLink/modules/customers/new-account-dash#/account?id='+this.StoreStateT.OnlineTransactionIaccessUserID+'&b=1'              
            })
        }
    })
        
}



////

         
////

}
</script>